<div class="time-picker-wrap">
  <div (click)="$event.preventDefault()" class="time-picker-content">
    <rt-group class="group-switcher" variant="horizontal stacked">
      <rt-button
        [class.active]="activeTab === 'date'"
        (click)="switchTab('date')"
        variant="switcher"
      >
        <rt-icon name="event"></rt-icon>
        {{ 'rtu.common.date' | translate }}
      </rt-button>
      <rt-button
        [class.active]="activeTab === 'time'"
        (click)="switchTab('time')"
        variant="switcher"
      >
        <rt-icon name="access-time"></rt-icon>
        {{ 'rtu.common.time' | translate }}
      </rt-button>
    </rt-group>

    <div class="tabs">
      <div *ngIf="activeTab === 'date'" class="tab tab-date">
        <rt-date-picker [value]="tmpValue!.date" (valueChange)="handleDateChange($event!)">
        </rt-date-picker>
      </div>

      <div *ngIf="activeTab === 'time'" class="tab tab-time">
        <div class="inputs-wrap">
          <rt-input
            [value]="tmpValue!.time"
            (valueChange)="handleTimeChange($event!)"
            (click)="timeDropdown.open = !timeDropdown.open"
            rt-overlay-origin
            #timeDropdownTrigger="rtOverlayOrigin"
          >
          </rt-input>
        </div>

        <div class="time-zone-wrap">
          <rt-time-zone-picker
            [timezone]="tmpValue!.zone"
            (zoneChange)="handleTimeZoneChange($event)"
          ></rt-time-zone-picker>
        </div>

        <ng-template
          #timeDropdown="rtConnectedOverlay"
          [origin]="timeDropdownTrigger"
          [width]="120"
          [hasBackdrop]="true"
          (backdropClick)="timeDropdown.open = false"
          rt-connected-overlay
        >
          <rt-time-picker-dropdown
            [currentSelected]="tmpValue!.time"
            (timeSelect)="handleTimeChange($event)"
          >
          </rt-time-picker-dropdown>
        </ng-template>
      </div>
    </div>
  </div>

  <div *ngIf="(!showTimeZonePicker && activeTab === 'time') || activeTab === 'date'" class="action">
    <rt-button (click)="applyChanges()" variant="primary">
      <rt-icon name="check"></rt-icon>
      {{ 'rtu.common.done' | translate }}
    </rt-button>
  </div>
</div>
